/**
 * main.jsx - Punto de entrada principal de la aplicación React
 * Monta el componente raíz <App /> en el DOM
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';

/* Estilos globales */
import './styles/index.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);
